import isObject from 'lodash/isObject';
import {applyAutoFilter, ReduxList} from '../../_libs/redux-observable-list';
import {buildParentChannelSyncNotifier} from '../../auth/utils/redux-lists';
import {BASE_REDUX_LIST_OPTIONS} from '../../config/redux-list/index';
import {sortByProperty} from '../../core-utilities/filters/filterUtils';
import {applyDefaultReduxListComponentOptions} from '../../core-utilities/redux/ReduxListContainer';
import {SYNC_MODEL_PATH, SYNC_PATH} from '../../core-utilities/rx-utils';
import {getForms} from '../reducers/state';
import {logger} from './logger';
import {FORM_LIST_PREFIX} from './state';


const parentPath = 'organizations';
const resourcePath = `forms`; // may need this for sync to post functionality
const childPath = 'forms';

const matchesAutoFilter = applyAutoFilter(['title'], 1);

export const reduxList = new ReduxList({
  ...BASE_REDUX_LIST_OPTIONS,
  prefix: FORM_LIST_PREFIX,
  getState: getForms,
  pageSize: 100,
  hasParentId: true,
  useDelete: true,
  useFiltering: true,
  useAutoFilter: true,
  useFilterOptions: false,
  useSortOptions: false,
  applySortOptions,
  isVisible,
  syncNotifier: buildParentChannelSyncNotifier(parentPath, childPath),
  syncModelPath: parentId => `${parentPath}/${parentId}/${childPath}/${SYNC_MODEL_PATH}`,
  listPath: parentId => `${parentPath}/${parentId}/${childPath}`,
  listSyncPath: parentId => `${parentPath}/${parentId}/${childPath}/${SYNC_PATH}`,
  deleteItemPath: itemId => `${resourcePath}/${itemId}`,
  logger,

  // cacheOptions: {
  //   localForage: asyncStorage,
  //   key: targetOptions.cacheName,
  // },
});

export const componentOptions = applyDefaultReduxListComponentOptions(reduxList.options);

function isVisible(item, filterData) {
  if (!isObject(item)) return false;
  if (!matchesAutoFilter(item, filterData.filter)) return false;
}

export function applySortOptions(list) {
  return list.sort(sortByProperty('title', true, true));
}



// WEBPACK FOOTER //
// ./src/js/forms/redux/forms.js